import axios from "axios";
import { getToken } from "./AuthHelper";
import { getHost } from './utils'

const SERVER_URL = getHost();

const post = (route, params, onSuccess, onError) => {
    axios({ method:'POST', 
        url: `${SERVER_URL}/api/${route}`, 
        headers: { authorization: `Bearer ${getToken()}` },
        data: params
    })
    .then((response) => {
        onSuccess(response.data)
    })
    .catch((error) => {
        onError((error.response)?error.response.data:error)
    });
}

const getDashboardStats = (params ,onSuccess, onError = ()=>{}) => {
    post('getDashboardStats', params, onSuccess, onError)
}

const getKpisData = (params ,onSuccess, onError = ()=>{}) => {
    post('getKpisData', params, onSuccess, onError)
}

const getMainDashboardData = (params ,onSuccess, onError = ()=>{}) => {
    post('getMainDashboardData', params, onSuccess, onError)
}

const getCATData = (params ,onSuccess, onError = ()=>{}) => {
    post('getCATData', params, onSuccess, onError)
}

const api = {
    getDashboardStats,
    getKpisData,
    getMainDashboardData,
    getCATData
}

export default api;